import { FileDropzone } from "../../filedropzone";
import { DownloadSpreadsheet } from "../../spreadsheet";
import { HeaderCreateProps } from "./headerCreateType";
import * as Css from "./style";
import { useHeaderCreate } from "./useHeaderCreate";

export default function HeaderCreate({ type, setType, onFileLoaded, onFileRemoved, setResult, result, loading }: HeaderCreateProps) {
    const { handleSelectType, variableDisabledCss} = useHeaderCreate({ result, loading, setType })

    return (
        <Css.ContainerHeader>
            <Css.ContainerTitle>
                <h1>Criação massiva</h1>
                <Css.ContainerOptionsCreate>
                    <p
                        onClick={() => handleSelectType("ticket")}
                        className={`${type === "ticket" ? "active" : ""} ${variableDisabledCss}`}
                    >
                        Tickets
                    </p>
                    <p
                        onClick={() => handleSelectType("user")}
                        className={`${type === "user" ? "active" : ""} ${variableDisabledCss}`}
                    >
                        Usuários
                    </p>
                    <p
                        onClick={() => handleSelectType("organization")}
                        className={`${type === "organization" ? "active" : ""} ${variableDisabledCss}`}
                    >
                        Organizações
                    </p>
                </Css.ContainerOptionsCreate>
            </Css.ContainerTitle>
            <FileDropzone onFileLoaded={onFileLoaded} onFileRemoved={onFileRemoved} setResult={setResult} />
            <Css.ContainerDownload>
                <DownloadSpreadsheet type={type} />
            </Css.ContainerDownload>
        </Css.ContainerHeader>
    );
}